import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Restoration } from 'models/order';
import { restorationPriceRows } from 'utils/restoration-price-rows';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { formatCurrency } from 'utils/format';

type PriceSpecProps = {
    restorations: Restoration[];
    currency: string;
};

const PriceSpec: FC<PriceSpecProps> = ({ restorations, currency }: PriceSpecProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const rows = useMemo(() => restorationPriceRows(restorations), [restorations]);
    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{translate('orders:ACTIONS_AND_MATERIALS')}</TableCell>
                        <TableCell align="right">{translate('orders:QUANTITY')}</TableCell>
                        <TableCell align="right">{translate('orders:UNIT_PRICE')}</TableCell>
                        <TableCell align="right">{translate('orders:TOTAL_EXCL_VAT')}</TableCell>
                        <TableCell align="right">{translate('orders:VAT')}</TableCell>
                        <TableCell align="right">{translate('orders:TOTAL_INCL_VAT')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row._id}>
                            <TableCell sx={{ minWidth: 300 }}>
                                {row.kind === 'ACTION' ? `${row.code || ''}, ${row.name}` : row.name}
                            </TableCell>
                            <TableCell align="right">{row.quantity}</TableCell>
                            <TableCell align="right">{formatCurrency(row.unitPrice, currency)}</TableCell>
                            <TableCell align="right">{formatCurrency(row.totalWithoutVat, currency)}</TableCell>
                            <TableCell align="right">{formatCurrency(row.vat, currency)}</TableCell>
                            <TableCell align="right">{formatCurrency(row.totalWithVat, currency)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PriceSpec;
